import { createFileRoute, Link } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { useTranslations } from "use-intl";
import { confirmEmailVerification } from "$/modules/auth/lib/auth";
import { AuthLayout } from "$/modules/auth/ui/auth-layout";
import { Button } from "$/modules/shared/ui/button";

type VerificationSearch = { userId?: string; secret?: string };

export const Route = createFileRoute("/$locale/verify-email/")({
	component: VerifyEmailPage,
	validateSearch: (search: Record<string, unknown>): VerificationSearch => ({
		userId: typeof search.userId === "string" ? search.userId : undefined,
		secret: typeof search.secret === "string" ? search.secret : undefined,
	}),
});

function VerifyEmailPage() {
	const { locale } = Route.useParams();
	const { userId, secret } = Route.useSearch();
	const t = useTranslations();
	const [state, setState] = useState<"pending" | "success" | "error">(
		"pending",
	);
	const [message, setMessage] = useState("");

	useEffect(() => {
		if (!userId || !secret) {
			setState("error");
			return;
		}
		void confirmEmailVerification(userId, secret).then((result) => {
			setState(result.success ? "success" : "error");
			if (!result.success) setMessage(result.message);
		});
	}, [secret, userId]);

	return (
		<AuthLayout
			locale={locale}
			title={t("auth.verificationTitle")}
			subtitle={
				state === "pending"
					? t("auth.verificationPending")
					: state === "success"
						? t("auth.verificationSuccess")
						: message || t("auth.verificationInvalid")
			}
		>
			{state !== "pending" && (
				<Button className="w-full" variant="default" asChild>
					<Link to="/$locale/signin" params={{ locale }}>
						{t("signIn")}
					</Link>
				</Button>
			)}
		</AuthLayout>
	);
}
